import { inject, Injectable } from '@angular/core';
import { TypeActionE } from '../modele/types';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  logs:Array<{msg:string, classe:string}> = [];
  classe:string = 'invalide';
  load:boolean = false; // Savoir si une donnée est en cours de chargement
  r:Router = inject(Router);
  loc:Location = inject(Location);

  accents = "ÀÁÂÃÄÅàáâãäåÒÓÔÕÖØòóôõöøÈÉÊËèéêëÇçÌÍÎÏìíîïÙÚÛÜùúûüÿÑñ";
  pasaccents = "aaaaaaaaaaaaooooooooooooeeeeeeeecciiiiiiiiuuuuuuuuynn";

  // mansory: Array<any> = new Array(5); // Nombre de colonnes à afficher pour les notices

  constructor() { }

  setMsg(msg:string, classe:string = 'invalide'){
    this.logs.push({msg, classe});
    this.load = false;
  }
  /** Générer une date */
  setDate(type:string = TypeActionE.maj){
    const d:Date = new Date();
    return `${d.getFullYear()}-${d.getMonth()+1}-${d.getDay()}`
  }
  goBack(route:string, msg?:string, classe:string = 'invalide'){
    if(msg) this.setMsg(msg, classe);
    route == 'back' ? this.loc.back() : this.r.navigateByUrl(route);
  }
  /**
   *
   * @param id ID à indiquer dans la route
   * @param route Route où rediriger
   * @param tab Le tableau de référence
   */
  next(id:number, route:string, tab:number) {
    id >= tab ? id = 0 : ++id;
    this.r.navigate([route, id])
  }
  back(id:number, route:string, tab:number) {
    id > 0 ? --id : id = tab - 1;
    this.r.navigate([route, id])
  }
  /** Remplacer les caractères spéciaux et les accents */
  safeSearch(a: string): string {
    let str = a.toLowerCase();
    if (typeof a === 'string') {
      let corrections: any = {};

      for (let i = 0; i < this.accents.length; ++i) {
        corrections[this.accents[i]] = this.pasaccents[i];
      }
      corrections['Œ'] = 'OE';
      corrections['œ'] = 'oe';

      str = str.replace(/./g, (n: any) => corrections[n] ? corrections[n] : n);

      str = str.replace(/&amp;/g, '_');
      str = str.replace(/_amp;/g, '');
      str = str.replace(/&lt;/g, '_');
      str = str.replace(/_lt;/g, '_');
      str = str.replace(/&gt;/g, '_');
      str = str.replace(/_gt;/g, '_');
      str = str.replace(/(-|#|"|<|>|@|:|\.|,|;|'|`|%|!|²|=|÷|\+|\?|\/|\[|\]|\{|\}|\*|\^|\$|\\|`|"|'|¨|€|£|¤|µ|§|~|ƒ|„|©|°)/g, '_')
    }
    return str;
  }
  /** Créer un uuid */
  getUniqueId(parts: number): string {
    const stringArr = [];
    for(let i = 0; i< parts; i++){
      // tslint:disable-next-line:no-bitwise
      const S4 = (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      stringArr.push(S4);
    }
    return stringArr.join('-');
  }
  
  /** Afficher la propriété dans le template */
  getPropObj(obj:any){
    return obj.hasOwnProperty('theme') ? obj.theme : obj.mot;
  }
}
